
































import Vue from 'vue';
import { Component, InjectReactive, Prop, Watch } from 'vue-property-decorator';
import CourseSearchCards from 'frontend/components/search/CourseSearchCards.vue';
import { CourseData } from 'frontend/components/search/types';

@Component({
  components: {
    CourseSearchCards,
  },
})
export default class AllCourseSearchCards extends Vue {
  @Prop(Array) readonly courses!: CourseData[];
  @Prop(String) readonly queryID!: string;
  @InjectReactive() readonly searchQuery!: string;

  @Prop(Boolean) private inHeader!: boolean;
  @Prop(Boolean) private mobile!: boolean;
  @Prop(Boolean) private isStaffUser!: boolean;
  private viewRemainingCourses: boolean = false;

  private get numCoursesRow(): number {
    if (this.inHeader) {
      return 3;
    }
    return 4;
  }

  private get firstRowOfCourses(): CourseData[] {
    return this.courses.slice(0, this.numCoursesRow);
  }

  private get remainingCourses(): CourseData[] {
    return this.courses.slice(this.numCoursesRow, this.numCoursesTotal);
  }

  private get numCoursesTotal(): number {
    return this.courses.length;
  }

  private viewAll(): void {
    this.viewRemainingCourses = true;
  }

  @Watch('searchQuery')
  private reset(): void {
    this.viewRemainingCourses = false;
  }
}
